var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1111 0C23.8773 0 24.6121 0.257539 25.1539 0.715961C25.6956 1.17438 26 1.79614 26 2.44444V19.5556C26 20.2039 25.6956 20.8256 25.1539 21.284C24.6121 21.7425 23.8773 22 23.1111 22H2.88889C2.12271 22 1.38791 21.7425 0.846136 21.284C0.304364 20.8256 0 20.2039 0 19.5556V2.44444C0 1.79614 0.304364 1.17438 0.846136 0.715961C1.38791 0.257539 2.12271 0 2.88889 0H23.1111ZM22.3889 18.9444V12.4667C22.3889 11.4099 21.8928 10.3965 21.0097 9.64924C20.1266 8.90201 18.9289 8.48222 17.68 8.48222C16.4522 8.48222 15.0222 9.11778 14.3289 10.0711V8.71444H10.2989V18.9444H14.3289V12.9189C14.3289 11.9778 15.2244 11.2078 16.3367 11.2078C16.873 11.2078 17.3874 11.3881 17.7666 11.709C18.1458 12.0298 18.3589 12.4651 18.3589 12.9189V18.9444H22.3889ZM5.60444 6.79556C6.24804 6.79556 6.86527 6.57922 7.32036 6.19415C7.77545 5.80907 8.03111 5.2868 8.03111 4.74222C8.03111 3.60556 6.94778 2.67667 5.60444 2.67667C4.95702 2.67667 4.33612 2.89429 3.87832 3.28165C3.42052 3.66902 3.16333 4.1944 3.16333 4.74222C3.16333 5.87889 4.26111 6.79556 5.60444 6.79556ZM7.61222 18.9444V8.71444H3.61111V18.9444H7.61222Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a3aaf93246e36c60c07c85397d70a442.svg";
export { ForwardRef as ReactComponent };